import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';

import LayerIcon from '@material-ui/icons/Layers';
import MoreVertIcon from '@material-ui/icons/MoreVert';

const styles = theme => ({
    layerRow: {
        backgroundColor: theme.palette.secondary.main,
    },
    layerIcon: {
        color: theme.palette.secondary.contrastText,
    },
    layerHeading: {
        fontWeight: theme.typography.fontWeightBold,
        color: theme.palette.secondary.contrastText,
    },
    rowIconButtonRoot: {
        height: 40
    }
});

class LayerComponent extends React.Component {

    state = {
        expanded: true
    }

    handleChange = (event, expanded) => {
        this.setState({
            expanded: expanded
        });
    };

    toggleRowMenu = (event, el, index) => {
        const { onElementSelect, toggleRowMenu } = this.props;
        const { currentTarget } = event;
        
        if (el !== null && el !== undefined) {
            onElementSelect(el, index);
        }

        toggleRowMenu(currentTarget);
    }

    render() {
        const { classes, layer, layerIndex, children, toggleRowMenu, colSpan } = this.props;
        return (
            <TableBody>
                <TableRow classes={{ root: classes.layerRow }} >
                    <TableCell className="icon-cell"><LayerIcon className={classes.layerIcon} /></TableCell>
                    <TableCell colSpan={colSpan}>
                        <Typography className={classes.layerHeading}>{layer.name}</Typography>
                    </TableCell>
                    {
                        toggleRowMenu && 
                        <TableCell numeric>
                            <Tooltip title="Options">
                                <IconButton classes={{ root: classes.rowIconButtonRoot }} aria-label="Options" onClick={event => this.toggleRowMenu(event, layer, layerIndex)}>
                                    <MoreVertIcon />
                                </IconButton>
                            </Tooltip>
                        </TableCell>
                    }
                </TableRow>
                {children}
            </TableBody>
        )
    }
}

LayerComponent.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(LayerComponent);


// WEBPACK FOOTER //
// ./src/Components/Presentation/Campaigns/MediaPlan/LayerComponent.js